import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import i18nContext from 'components/i18n-context';
import { ReactComponent as PhoneIcon } from 'assets/phone-icon.svg';
import { AuthorizationBackButton } from 'components/common/AuthorizationBackButton/AuthorizationBackButton';
import { ConfirmCodeWrapper } from 'components/common/ConfirmCodeWrapper/ConfirmCodeWrapper';
import { SMS_ERROR_CODE_DISABLE, TWO_FACTOR_AUTH_TYPES } from 'components/common/constants';
import { getErrorMessageForAlert } from 'services/utils';
import './Confirmations.scss';

const Google2FA = ({ sms, handleSms, error, authStore }) => {
  const i18n = useContext(i18nContext);
  const [alertState, setAlertState] = useState({ type: '', message: '' });
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (SMS_ERROR_CODE_DISABLE.includes(error?.code)) {
      setIsDisabled(true);
      handleSms(sms, true);
    }
    if (error) {
      setAlertState({ type: 'warning', message: getErrorMessageForAlert(i18n, error) });
      authStore.setCode('');
    } else {
      setAlertState({ type: '', message: '' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  const onComplete = (sms) => {
    handleSms(sms);
    setAlertState({ type: '', message: '' });
  };

  const handleSwitchToAnotherMethod = () => authStore.setIsShowSwitchConfirmationMethodScreen(true);

  return (
    <div className={'authorization-form'} id={'form1'}>
      <PhoneIcon className={'svg-phone-icon registration-icon'} />
      <h1 className={'authorization-title'}>{i18n.getMessage('2fa.title')}</h1>
      <ConfirmCodeWrapper
        type={TWO_FACTOR_AUTH_TYPES.GOOGLE_AUTH}
        isDisabled={isDisabled}
        error={error}
        onComplete={onComplete}
        alertState={alertState}
        isSwitchToAnotherConfirmationMethod={true}
        handleSwitchToAnotherMethod={handleSwitchToAnotherMethod}
      />
      <AuthorizationBackButton
        type={'login'}
        isGoogle2FAAuth={authStore.isGoogle2FAEnabled}
        confirmationType={authStore.confirmationActionType}
      />
    </div>
  );
};

Google2FA.propTypes = {
  sms: PropTypes.string.isRequired,
  handleSms: PropTypes.func.isRequired,
  error: PropTypes.any,
  authStore: MobXPropTypes.observableObject
};

export default inject('authStore')(observer(Google2FA));
